import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { parseQueryString } from '../../utils/commonUtils';
import * as googleAnalyticsUtil from '../../utils/googleAnalyticsUtil';
import * as actions from '../../modules/configuration/actions';

import Header from '../common/header/index';
import Footer from '../common/footer/index';

import './styles.css'

export class Layout extends Component {
  componentDidMount() {
    var queryString = parseQueryString();
    var connectParams = queryString['connectParams'];
    if (connectParams) {
      this.props.actions.loadConnectParams(connectParams);
    }
    googleAnalyticsUtil.setLocation('/connect-direct-hit');
    this.props.actions.loadGoogleAnalyticsTracker();
  }

  render() {
    const connectParams = this.props.configuration.connectParams;

    return (
      <div className="main">
        <Header {...connectParams} />
        {this.props.children}
        <Footer {...connectParams} />
      </div>
    );
  }
}

export default connect(
  store => ({ configuration: store.configuration }),
  dispatch => ({ actions: bindActionCreators(actions, dispatch) })
)(Layout);


// WEBPACK FOOTER //
// ./src/components/layout/index.js